import React from 'react';

import { image } from 'services'

import { container, success } from './style'

const SuccessMessage = () => (
  <div className="form-container">
    <img className="success-img" src={image('/dashboard/valuation/icono-admin-exito-upload.png')}/>
    <h4>Mensaje enviado</h4>
    <p>
      Muy pronto, uno de nuestros asesores se pondrá en contacto contigo para atenderte personalmente y brindarte la información que necesitas. ¡Gracias!
    </p>
    <style jsx>{success}</style>
  </div>
)

export default SuccessMessage
